import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import { useCurrentCompanyId } from "hooks/auth";
import { showToast } from "utils/helpers";
import type { InviteUserPayload, UserListItem } from "../../../types/userInvite";
import { getInviteErrorMessage } from "../inviteErrorMessages";

interface InviteUserError {
  message: string;
  code?: string;
  errors?: Record<string, string[]>;
}

const inviteUser = async (
  companyId: number,
  payload: InviteUserPayload
): Promise<UserListItem> => {
  const response = await apiV1.post<UserListItem>(
    `companies/${companyId}/users/invite`,
    payload
  );
  return response.data;
};

export const useInviteUserMutation = () => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation<UserListItem, InviteUserError, InviteUserPayload>({
    mutationFn: (payload) => inviteUser(companyId!, payload),
    retry: false,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["users", companyId] });
      showToast(
        `Invite sent to ${data.email}`,
        "Success",
        true
      );
    },
    onError: (error) => {
      const message = getInviteErrorMessage(error?.code);
      showToast(message, "Error");
    },
  });
};
